@if (showSpinner) {
  <app-loader> </app-loader>
}
<main class="content-wrapper" [ngStyle]="{ background: selectedMode === 'dark' ? '#111526' : '' }">
  <div class="container-fluid mb-4 ">

    <div class="leaveManagmentParent">
      <div class="leftLM" [ngClass]="{ 'dark-text': selectedMode === 'dark' }">
        <p class="headingattandace">Attendance Request </p>
      </div>
    </div>
    <!-- 2nd row -->
    <!-- tabele section -->
    <div class="tablewidth mt-4">
      <table class="bg-white" >
        <tr class="tableHead" [ngClass]="{ 'dark-tableHead': selectedMode === 'dark'  }">
          <th class="text-center"> Type</th>
          <th class="text-center">Old Value</th>
          <th class="text-center">Req Value</th>
          <th class="text-center">Date</th>
          <th class="text-center">Status</th>
          <th class="text-center">Limit</th>
        </tr>
        @for (item of attendanceRequest; track item) {
        <tr class="tableData " [ngClass]="{ 'dark-tabletr': selectedMode === 'dark',
        'borderGreen': item.status === 'approved',
        'borderRed': item.status === 'rejected',
        'borderYellow': item.status === 'pending' }">
            <td class="text-center">{{item.type | titlecase}}</td>
            <td class="text-center" >{{item.old_value}}</td>
            @if (item.type === 'check_in') {
              <td class="text-center">{{item.check_in}}</td>
            }
            @if (item.type === 'check_out') {
              <td class="text-center">{{item.check_out}}</td>
            }
            @if (item.type === 'overtime') {
              <td class="text-center">{{item.overtime}}</td>
            }
            <td class="text-center" >{{item.date}}</td>
          @if (item.status === 'approved') {
            <td class="text-center "> <div [ngClass]="{ 'btn approvebtn': item.status === 'approved'}"> Approved</div></td>
          }
          @if (item.status === 'rejected') {
            <td class="text-center "> <div [ngClass]="{' btn rejectebtn': item.status === 'rejected'}"> Rejected</div></td>
          }
          @if (item.status === 'pending' || item.status == null) {
            <td class="text-center "> <div [ngClass]="{' btn pendingbtn': item.status === 'pending' || item.status == null}"> Pending</div></td>
          }
          <td class="text-center">
            @if (item.monthly_sequence > 2) {
              <span class="badge" style="background:#ffeaa7;color:#d63031;padding:4px 8px;border-radius:12px;font-size:11px;white-space:nowrap;font-weight:600;cursor:pointer;display:inline-flex;align-items:center;gap:4px;" [attr.data-tooltip]="'This attendance correction might be rejected as it\'s against the policy - you can only apply 2 corrections in a month'">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 9v2m0 4v2m8.228-2.228l-1.414-1.414M6.586 6.586L5.172 5.172M18 12a6 6 0 11-12 0 6 6 0 0112 0z"></path></svg>
                {{ item.monthly_sequence | ordinal:true }}
              </span>
            }
          </td>
        </tr>
          <tr class="tableData " [ngClass]="{ 'dark-tabletr': selectedMode === 'dark',
          'borderGreen': item.status === 'approved',
          'borderRed': item.status === 'rejected',
          'borderYellow': item.status === 'pending'}">
          <td class="text-center reason-head">Reason:</td>
          <td class="text-left" [attr.colspan]="5">{{item.reason}}</td>
        </tr>
        <tr class="tableData tableDataBorder " [ngClass]="{ 'dark-tabletr': selectedMode === 'dark',
        'borderGreen': item.status === 'approved',
        'borderRed': item.status === 'rejected',
        'borderYellow': item.status === 'pending'}">
          <!-- <td class="text-center">Reason:</td> -->
          <td class="pl-5 reason-td actionBtn" [attr.colspan]="5"></td>
          <!--
          <span id="rejectBy" *ngIf="a.status === 'rejected'">Rejected by:</span>
          <div class="btn rejectbtn" *ngIf="a.status === 'rejected'">
            <div class="rejectInner p-0">
              <div class="adminName"><b>{{a.admin_name}}</b></div>
              <div class="updatedAt">{{a.updated_at | date:'yyyy-MM-dd'}}</div>
            </div>
          </div> -->
        </tr>
      }
    </table>
  </div>
  <!-- Button trigger modal -->

</div>
</main>
